import React from 'react'
import { Helmet } from 'react-helmet'

import { Navbar, Landing, About, Skills, Blog, Education, Experience, Contacts, Projects, Achievement } from '../../components'
import { headerData } from '../../data/headerData'

function Main() {
    return (
        <div>
            <Helmet>
                <title>{headerData.name} - Portfolio</title>
            </Helmet>

            <Navbar />        
            <Landing />
            <About />
            <Skills />
            <Experience />
            <Education />            
            <Projects />
            <Achievement />
            {/* <Services /> */}
            <Blog />
            <Contacts />
            {/* <Footer /> */}
        </div>
    )
}

export default Main
